/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @11-09-2019 20:58:30
*/


const currentPageInRegisterReducer = (state = {pageName:"services",direction:"right",currentPage:false}, action) => {
	if(action.type === 'SET_CURRENT_PAGE') {
		var newState = {};
		Object.assign(newState,state);
		newState[action.key] = action.payload;
		return newState;
	}else {
		return state
	}
}

export default currentPageInRegisterReducer